import { defineMessages } from 'react-intl'

const scope = `procurify.discover-more.DiscoverMoreView.components.FeatureShowcase`

export default defineMessages({
  addOnBadgeText: {
    id: `${scope}.addOnBadgeText`,
    defaultMessage: 'Add-on',
  },
  andMoreLinkText: {
    id: `${scope}.andMoreLinkText`,
    defaultMessage: 'And more...',
  },
})
